const genericError = {
  toastId: 'GENERIC_ERROR',
  message: 'Ops! Tivemos um problema. Tente novamente mais tarde.'
}

const urlBlockedError = {
  toastId: 'URL_BLOCKED_ERROR',
  message:
    'Houve um erro com o seu Wifi. Por favor, tente em uma rede de celular (3G, 4G, 5G).'
}

export { genericError, urlBlockedError }
